<template>
   <div >
    <form method="POST" action="?" accept-charset="UTF-8" id="contactform"
        @submit.prevent="submitForm">

        <div class="form-group mb-4">
            <label for="name">Name<span class="required">*</span></label>
            <input required :class="['input-class']" v-model="contents.name" placeholder="Name" />
            <div v-if="checkErrors('name')" class="error">{{ errors.name }}</div>
        </div>
        <div class="form-group mb-4">
            <label for="email">Email<span class="required">*</span></label>
            <input required :class="['input-class']" v-model="contents.email" type="text"
                placeholder="Email Address" />
            <span v-if="checkErrors('email')" class="error">{{ errors.email }}</span>
        </div>
        <div class="form-group two mb-4">
            <label for="phone">Business Phone Number<span class="required">*</span></label>
            <input :class="['input-class']" v-model="contents['businessphone']" type="tel"
                placeholder="000-000-0000 or similar" @keyup="validatePhone()" aria-hidden="true"/>
        </div>
        <div class="form-group mb-4">
            <label for="body">Message<span class="required">*</span></label>
            <textarea placeholder="Body" v-model="contents.message" cols="30" rows="5"
                id="description" :class="['input-class', 'bg-white']"></textarea>
            <span v-if="checkErrors('message')" class="error">{{ errors.message }}</span>
        </div>
        <div class="form-group">
            <button type="submit"
                class="enabled:bg-slate-300 enabled:text-black font-bold disabled:bg-yellow-400/50 disabled:text-yellow-500  text-white my-2 h-10 px-10"
                :disabled="(invalid ? true : false)">{{ buttonMessage }}</button>
        </div>
    </form>
   </div>
</template>

<script>
import { router } from '@inertiajs/vue3'
import { api } from '@/api.js'

export default {
   name: "ContactForm",
    watch: {
        contents: {
            handler(n) {
                if(n?.businessphone?.length > 0) {
                    this.invalid=true;
                }else{
                    this.invalid=false;
                }
            },
            deep: true,
            immediate: true
        }
    },
   computed: {},
   data() {
       return {
            form: null,
            errors: {},
            contents: {},
            invalid: true,
            buttonMessage: 'SEND'
       }
   },
   mounted() {
        if (import.meta.env.MODE === 'development') {
            this.contents = {
                'email': 'address@acdubs.com',
                'name': 'Adam',
                'message': 'msg'
            };
        }
   },
   methods: {
    checkErrors(x) {
        return this.errors && this.errors[x] ? true : false;
    },
        validatePhone() {
            if(this.contents['businessphone'].length > 0) {
                this.invalid=true;
            }else{
                this.invalid=false;
            }
        },
        submitForm(e) {
            if (this.contents?.businessphone?.length > 0) {
                // this.errors.planet = "Are you sure that's the planet we live on?";
                return false;
            }
            if (this.contents?.message.length < 1) {
                this.errors.message = "Why not write a message?";
                return false;
            }
            this.buttonMessage='Thank you!';

            this.invalid=true;
            // router.post('/post-contact', this.contents);
             api.put('/post-contact', this.contents)
             .then(d => {
                setTimeout(() => {
                    this.invalid=false;
                    this.contents={name: '', email: '', message: ''};
                    this.buttonMessage='SEND';
                }, 5000);
             })

        }
   }
}
</script>
<style>
.form-group.two {
    display: none;
}
.input-class {
    padding: 10px;
    width: 100%;
    margin: 2px;
    color: black;
    box-shadow: 4px 4px 8px hsla(66, 71%, 30%, 0.1), -4px -4px 8px hsla(66, 71%, 20%, 0.1);
    @apply border border-slate-500/20;
}
label {
    padding-left: 4px;
    font-size: .95em;
}
.input-class::placeholder {
    @apply text-slate-400;
}
</style>
